import { MultiLoadAutocomplete } from 'form';
import { useTranslation } from 'i18n';
import { SectionContainer, Typography } from 'ui';

type LoadsSectionProps = {
  hasShipment?: boolean;
  shipmentName?: string;
  salesOrderSlug?: string;
};

export const LoadsSection = ({ hasShipment, salesOrderSlug, shipmentName }: LoadsSectionProps) => {
  const { t } = useTranslation('orders');

  return (
    <SectionContainer title={t('shipmentLoadsSection.title')} columns={1}>
      <MultiLoadAutocomplete
        label={t('shipmentLoadsSection.labels.loads')}
        name="load_ids"
        assignableToShipment={shipmentName}
        hasShipment={hasShipment}
        salesOrderSlug={salesOrderSlug}
      />
      <Typography>{t('shipmentLoadsSection.description')}</Typography>
    </SectionContainer>
  );
};
